import { Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { networkMock } from '../../../api';
import { NETWORK_COLORS, StackedBar } from '../graph';
import { CardBaseHeaderStyled, NetworkCard } from './Styles';

export const Network = () => {
  const { t } = useTranslation();

  const networkData = networkMock;

  return (
    <NetworkCard>
      <CardBaseHeaderStyled noBorder small>
        <Label fontSize="21" semibold>
          {t('Network')}
        </Label>
      </CardBaseHeaderStyled>
      <StackedBar
        {...networkData}
        showLegend={false}
        colors={NETWORK_COLORS}
        style={{ height: '100%', width: '100%' }}
      />
    </NetworkCard>
  );
};
